import React from 'react';
import DashboardLayout from '../components/DashboardLayout';
import BookingFormV2 from '../components/booking/BookingFormV2';

const BookingV2 = () => (
  <DashboardLayout>
    <BookingFormV2 />
  </DashboardLayout>
);

export default BookingV2;
